import {createContext} from "react"

const ToastContext=createContext({})

export default ToastContext